import { assertUnreachable } from '@luminovo/commons';
import { ModulePermission } from '@luminovo/http-client';

export type ModulePermissionTest =
    | ModulePermission
    | {
          permissions: ModulePermission[];
          type: 'union' | 'intersection';
      }
    | ((permissions: ModulePermission[]) => boolean);

export function isAuthorizedForModule(modulePermissions: ModulePermission[], test: ModulePermissionTest): boolean {
    if ('module' in test) {
        return modulePermissions.some((p) => p.module === test.module && p.permission === test.permission);
    }
    if (typeof test === 'function') {
        return test(modulePermissions);
    }
    if (test.type === 'union') {
        return test.permissions.some((testP) =>
            modulePermissions.some((p) => p.module === testP.module && p.permission === testP.permission),
        );
    } else if (test.type === 'intersection') {
        return test.permissions.every((testP) =>
            modulePermissions.some((p) => p.module === testP.module && p.permission === testP.permission),
        );
    }
    assertUnreachable(test.type);
}
